import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {NgxWebstorageModule} from 'ngx-webstorage';
import { ChartsModule,ThemeService } from 'ng2-charts';
import { FormsModule,ReactiveFormsModule} from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
// primeng module start
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import {SplitterModule} from 'primeng/splitter';
import {InputNumberModule} from 'primeng/inputnumber';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {SlideMenuModule} from 'primeng/slidemenu';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { EditorModule } from 'primeng/editor';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { TooltipModule } from 'primeng/tooltip';
import { AdminRoutingModule } from './admin-routing.module';
import { DragDropModule } from 'primeng/dragdrop';
import { LookupCategoryAddComponent, LookupCategorySearchComponent
  , LookupMasterAddComponent, LookupMasterSearchComponent 
, CountrySearchComponent, CountryViewModalComponent,StateViewModalComponent,CityViewModalComponent,EmailtemplateViewModalComponent,
StateSearchComponent,
CitySearchComponent,
ClaimsMasterSearchComponent,
ApplicationFeaturesSearchComponent,
ApplicationClaimTypesSearchComponent,
UserClaimsComponent, UserRoleDefaultFeaturesComponent,
UserapprovalSearchComponent, ClientRequisitionContactComponent,ClientRequisitionViewModalComponent,
ClientCheckListsComponent,ClientApprovalSearchComponent
} from './components';
import { EmailTemplateAddComponent } from './components/email-template/email-template-add/email-template-add.component';
import { EmailTemplateSearchComponent } from './components/email-template/email-template-search/email-template-search.component';
//import { StateViewModalComponent } from './components/state/state-search/state-view-modal/state-view-modal.component';
import { CompanyApprovalSearchComponent } from './components/company-approval/company-approval-search/company-approval-search.component';
import { CompanyApprovalViewComponent } from './components/company-approval/company-approval-view/company-approval-view.component';
import { EmailTemplateViewComponent } from './components/email-template/email-template-view/email-template-view.component';
import { ClientMasterComponent } from './components/client-master/client-master.component';
import { VendorClientAssignmentComponent } from './components/vendor-client-assignment/vendor-client-assignment.component';
import { EmailConfigurationComponent } from './components/email-configuration/email-configuration.component';
import { SendEmailComponent } from './components/send-email/send-email.component';
import { ImportInvoiceApplicantComponent } from './components/import-invoice-applicant/import-invoice-applicant.component';
//import { ClientRequisitionViewModalComponent } from './components/client-requisition-contact/client-requisition-view-modal/client-requisition-view-modal.component';
import { CreateVendorComponent } from './components/create-vendor/create-vendor.component';
import { VendorProfileStatusComponent } from './components/vendor-profile-status/vendor-profile-status.component';


// import {DialogService} from 'primeng/dynamicdialog';
import { NgxDocViewerModule } from 'ngx-doc-viewer'; 
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { QuillModule } from 'ngx-quill';
import { SearchPageThemeComponent } from './components/search-page-theme/search-page-theme.component';
import { SearchPageColumnsComponent } from './components/search-page-columns/search-page-columns.component';
import { SearchThemecolumnsAssignComponent } from './components/search-themecolumns-assign/search-themecolumns-assign.component';
import { SearchThemeusersAssignComponent } from './components/search-themeusers-assign/search-themeusers-assign.component';
import { RateChangeRequestComponent } from './components/rate-change-request/rate-change-request.component';
import { DocumentTemplateAddComponent } from './components/document-template/document-template-add/document-template-add.component';
import { DocumentTemplateSearchComponent } from './components/document-template/document-template-search/document-template-search.component';
import { DocumentTemplateViewComponent } from './components/document-template/document-template-view/document-template-view.component';
import { DocumentTemplateViewModalComponent } from './components/document-template/document-template-view-modal/document-template-view-modal.component';

import {FiltersModule} from '../filters/filters.module';
import {PickListModule} from 'primeng/picklist';
import { DvmsSystemAlertsComponent } from './components/dvms-system-alerts/dvms-system-alerts.component';
import { EmailChannelComponent } from './components/email-channel/email-channel.component';
import { VendorOnboardingComponent } from './components/vendor-onboarding/vendor-onboarding.component';
import { VendorOnboardProcessSearchComponent } from './components/vendor-onboard-process-search/vendor-onboard-process-search.component';
import { VendorOnboardApprovalViewComponent } from './components/vendor-onboard-approval-view/vendor-onboard-approval-view.component';
import { VendorOnboardApprovalSearchComponent } from './components/vendor-onboard-approval-search/vendor-onboard-approval-search.component';

@NgModule({
  declarations: [
      LookupCategoryAddComponent, 
      LookupCategorySearchComponent, 
      LookupMasterAddComponent, 
      LookupMasterSearchComponent,
      CountrySearchComponent,
      StateSearchComponent,
      CitySearchComponent,
      EmailTemplateAddComponent,
      EmailTemplateSearchComponent,
      ClaimsMasterSearchComponent,
      ApplicationFeaturesSearchComponent,
      ApplicationClaimTypesSearchComponent,
      UserClaimsComponent,
      UserRoleDefaultFeaturesComponent,
      StateViewModalComponent,
      UserapprovalSearchComponent,
      CompanyApprovalSearchComponent,
      CompanyApprovalViewComponent,
      EmailTemplateViewComponent,
      ClientMasterComponent,
      VendorClientAssignmentComponent,
      ClientRequisitionContactComponent,
      ClientRequisitionViewModalComponent,
      EmailConfigurationComponent,
      ClientCheckListsComponent,
      SendEmailComponent,
      ClientApprovalSearchComponent,
      ImportInvoiceApplicantComponent,
      CreateVendorComponent,
      VendorProfileStatusComponent,
      SearchPageThemeComponent,
      SearchPageColumnsComponent,
      SearchThemecolumnsAssignComponent,
      SearchThemeusersAssignComponent,
      RateChangeRequestComponent,
      DocumentTemplateAddComponent,
      DocumentTemplateSearchComponent,
      DocumentTemplateViewComponent,
      DocumentTemplateViewModalComponent,
      DvmsSystemAlertsComponent,
      EmailChannelComponent,
      VendorOnboardingComponent,
      VendorOnboardProcessSearchComponent,
      VendorOnboardApprovalViewComponent,
      VendorOnboardApprovalSearchComponent,

    ],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgxSpinnerModule,
    AccordionModule,
    ChartsModule,
    CommonModule,
    ChartsModule,
    TableModule,
    CalendarModule,
		SliderModule,
		DialogModule,
		MultiSelectModule,
		ContextMenuModule,
		DropdownModule,
		ButtonModule,
		ToastModule,
    InputTextModule,
    ProgressBarModule,
    MenuModule,
    MenubarModule,
    CardModule,
    PanelModule,
    TabViewModule,
    InputSwitchModule,
    CheckboxModule,
    MessagesModule,
    FileUploadModule,
    ConfirmPopupModule,  
    SplitterModule, 
    InputNumberModule,
    TieredMenuModule,  
    SlideMenuModule, 
    DynamicDialogModule,
    ConfirmDialogModule,
    AdminRoutingModule,
    EditorModule,
    NgxWebstorageModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgxDocViewerModule,
    ProgressSpinnerModule,
    QuillModule.forRoot(),
    TooltipModule,
    DragDropModule,
    FiltersModule,
    PickListModule
  ],
  entryComponents: [
    CountryViewModalComponent,StateViewModalComponent,CityViewModalComponent,EmailtemplateViewModalComponent,ClientRequisitionViewModalComponent
    ,DocumentTemplateViewModalComponent
  ]
  // providers: [DialogService]
})
export class AdminModule { }
